import React, { CSSProperties, ReactNode } from 'react';

/**
 * {@docCategory TriArea}
 */
export interface TriAreaProps {
   /**
    * The left content.
    */
   left?: ReactNode;

   /**
    * The middle content.
    */
   middle?: ReactNode;

   /**
    * The right content.
    */
   right?: ReactNode;

   /**
    * The vertical alignment of items
    *
    * @defaultvalue 'center'
    */
   verticalAlign?: 'top' | 'center' | 'bottom';

   /**
    * Sets a className on the outer panel.
    */
   className?: string;

   /**
    * Sets styles on the outer panel.
    */
   style?: CSSProperties;
}

export const TriArea = (props: TriAreaProps) => {
   const { verticalAlign = 'center' } = props;
   return (
      <div className={`uf-tri-area ${props.className || ''}`} style={props.style}>
         {props.left && <div className={"uf-tri-area-outer-left"}>
            {<div className={`uf-tri-area-inner-left uf-tri-area-inner-align-${verticalAlign}`}>{props.left}</div>}
         </div>}
         {props.middle && <div className={"uf-tri-area-outer-middle"}>
            {<div className={`uf-tri-area-inner-middle uf-tri-area-inner-align-${verticalAlign}`}>{props.middle}</div>}
         </div>}
         {props.right && <div className={"uf-tri-area-outer-right"}>
            {<div className={`uf-tri-area-inner-right uf-tri-area-inner-align-${verticalAlign}`}>{props.right}</div>}
         </div>}
      </div>
   );
};
